import { getAdminPath } from '@doss/common-all'
import {
  BreadcrumbObjectType,
  GetWorkspaceByObjectQuery,
  ViewableObjectType,
} from '~/common/generated/apollo-operations'
import constants from '../config/config'

export type WorkspaceViewsByObject = GetWorkspaceByObjectQuery['workspaceByObject']['views']

export function getAdminUrl(
  objectType: BreadcrumbObjectType,
  objectId: string,
  organizationId: string,
): string {
  return `${constants.adminWebUrl}${getAdminPath(objectType, objectId, organizationId)}`
}

/**
 * Gets the back navigation path from the workflows page
 */
export function getBackNavigationWorkflowPage(asPath: string): string {
  const path = asPath
  const isWorkflowPage = path.includes('/workflows')
  if (!isWorkflowPage) {
    return path
  }

  const workflowIndex = path.indexOf('/workflows')
  return path.slice(0, workflowIndex)
}

interface ObjectDetails {
  objectId: string
  objectName: string
  objectType:
    | BreadcrumbObjectType.TABLE
    | BreadcrumbObjectType.TABLE_ROW
    | BreadcrumbObjectType.DOCUMENT
    | BreadcrumbObjectType.EMBED
  icon?: {
    id: string
    name: string
  } | null
}

/**
 * Gets the object details from the view
 */
export function getObjectDetailsFromView(view: WorkspaceViewsByObject[number]): ObjectDetails {
  let objectId: string | undefined = undefined
  let objectName: string | undefined = undefined
  let objectType: BreadcrumbObjectType | undefined = undefined
  let icon: { id: string; name: string } | null = null

  switch (view.viewableObjectType) {
    case ViewableObjectType.TABLE: {
      if (!view.table) {
        throw new Error('Table is undefined')
      }
      objectId = view.table.id
      objectName = view.table.name
      objectType = BreadcrumbObjectType.TABLE
      icon = view.table.icon
      break
    }
    case ViewableObjectType.TABLE_ROW: {
      if (!view.tableRow) {
        throw new Error('TableRow is undefined')
      }
      objectId = view.tableRow.id
      objectName = view.tableRow.name
      objectType = BreadcrumbObjectType.TABLE_ROW
      break
    }
    case ViewableObjectType.DOCUMENT: {
      if (!view.document) {
        throw new Error('Document is undefined')
      }
      objectId = view.document.id
      objectName = view.document.name
      objectType = BreadcrumbObjectType.DOCUMENT
      break
    }
    case ViewableObjectType.CHART:
      throw new Error('Not implemented')
    case ViewableObjectType.WORKSPACE:
      throw new Error('Not implemented')
    case ViewableObjectType.EMBED: {
      if (!view.embed) {
        throw new Error('Embed is undefined')
      }
      objectId = view.embed.id
      objectName = view.embed.name
      objectType = BreadcrumbObjectType.EMBED
      break
    }
    case ViewableObjectType.FORM_V2:
      throw new Error('Not implemented')
  }

  return { objectId, objectName, objectType, icon }
}
